import { Style } from '@react-pdf/types'

const container = ({ noGutters }: { noGutters?: boolean }): Style => ({
  width: '100%',
  backgroundColor: 'white',
  borderRadius: '6px',
  border: '1px solid #c9c9cb',
  padding: noGutters ? undefined : '12px',
  overflow: 'hidden'
})

export default function getStyles({ noGutters }: { noGutters?: boolean }) {
  return {
    container: container({ noGutters })
  }
}
